<template>
  <div class="attribute_content">
    <div class="attribute_title">
      <span>
        {{ AttributeGroups.Name }}
      </span>
    </div>
    <div class="attribute_items" v-if="AttributeGroups.SelectType == 0">
      <van-radio-group
        @change="RadioProductAttribute"
        v-model="Option"
        direction="horizontal"

      >
        <van-radio
        icon-size="18pt"
          :name="item"
          v-for="(item, index) in AttributeGroups.ProductAttribute"
          :key="index"
          >
          <span class="attribute_item_name"> {{ item.Name + "" + item.PriceFormat }} </span>
          </van-radio
        >
      </van-radio-group>
    </div>
    <div class="attribute_items" v-if="AttributeGroups.SelectType == 100">
      <van-checkbox-group
        v-model="checkedAttributes"
        direction="horizontal"
        @change="CheckedProductAttribute"
      >
        <van-checkbox
          shape="square"
          v-for="(item, index) in AttributeGroups.ProductAttribute"
          :key="index"
          :name="item.Id"
        >
          {{ item.Name + "" + item.PriceFormat }}</van-checkbox
        >
      </van-checkbox-group>
    </div>
  </div>

  <!--

  <el-form-item
    :label="AttributeGroups.Name"
    v-if="AttributeGroups.SelectType == 0"
  >

    <el-radio
      v-for="(item, index) in AttributeGroups.ProductAttribute"
      :key="index"
      v-model="Option"
      :label="item.Id"
      @change="RadioProductAttribute(item)"
      >{{ item.Name + "" + item.PriceFormat }}</el-radio
    >
  </el-form-item>

  <el-form-item
    :label="AttributeGroups.Name"
    v-if="AttributeGroups.SelectType == 100"
  >
    <el-checkbox-group
      @change="CheckedProductAttribute"
      v-model="checkedAttributes"
      :min="0"
      :max="100"
    >
      <el-checkbox
        v-for="(item, index) in AttributeGroups.ProductAttribute"
        :key="index"
        :label="item.Id"
        >{{ item.Name }}</el-checkbox
      >
    </el-checkbox-group>
  </el-form-item> -->
</template>
<script>
import axios from "../../src/commons/AxiosMethod.js"

export default {
  name: "header",
  data () {
    return {
      AttributeGroups: {},
      checkedAttributes: [],
      Option: ""
    }
  },
  props: {
    AttributeGroup: {}
  },
  components: {},
  mounted () {
    this.AttributeGroups = this.AttributeGroup

    // 这个是页面创建的时候，就执行相关的方法
  },
  methods: {
    // 单选赋值
    RadioProductAttribute (item) {
      var arr = []
      arr.push(item)
      console.log(arr)
      this.$emit("update:modelValue", arr)
    },
    // 多选赋值
    CheckedProductAttribute () {
      var arr = []
      for (var i = 0; i < this.AttributeGroups.ProductAttribute.length; i++) {
        this.checkedAttributes.forEach((e) => {
          if (this.AttributeGroups.ProductAttribute[i].Id == e) {
            arr.push(this.AttributeGroups.ProductAttribute[i])
          }
        })
      }
      console.log(arr)
      this.$emit("update:modelValue", arr)
    }

  }
}
</script>
<style  lang="scss"  scoped>
.attribute_content {
  padding: 10px;
  .attribute_title {
    width: 100%;
    height: 30px;
    font-size: 16pt;
    line-height: 30px;
    border-bottom: 1px solid #eee;
    span {
      padding: 40px 5px;
    }
  }
  .attribute_items {
    padding: 5px;
    .attribute_item_name{
      font-size: 10pt;
    }
  }
}
</style>
